// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'D:/Working/BlueTech/AnLam/frontend-hrm/node_modules/.pnpm/@umijs+renderer-react@4.7.2_0cfc7fbc682fc3beb70af506c4b5e48c/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
